import { animationState } from './state/_.initialState.animationState';
import { appState } from './state/_.initialState.appState';
import { currentIds } from './state/_.initialState.currentIds';
import { editorCommands } from './state/_.initialState.editorCommands';
import { holodeckState } from './state/_.initialState.holodeckState';
import { logs } from './state/_.initialState.logs';
import { realtimeState } from './state/_.initialState.realtime';
import { user } from './state/_.initialState.user';
import { qualities } from './state/admin.initialState.qualities';
import { allBackdrops } from './state/core.initialState.allBackdrops';
import { allMaterials } from './state/core.initialState.allMaterials';
import { allShaders } from './state/core.initialState.allShaders';
import { assetPacks } from './state/core.initialState.assetPacks';
import { characters } from './state/core.initialState.characters';
import { generators } from './state/core.initialState.generators';
import { goldens } from './state/core.initialState.goldens';
import { keyframes } from './state/core.initialState.keyframes';
import { palettes } from './state/core.initialState.palettes';
import { projects } from './state/core.initialState.projects';
import { sceneItems } from './state/core.initialState.sceneItems';
import { settings } from './state/core.initialState.settings';
import { storyLines } from './state/core.initialState.storyLines';
import { ISloydStore } from './types';

export const initialState: ISloydStore = {
  // base
  appState,
  currentIds,
  user,
  holodeckState,
  realtimeState,
  editorCommands,

  generators,
  palettes,
  userPalettes: palettes,
  assetPacks,
  settings,
  goldens,
  sceneItems,
  characters,
  logs,

  projects,
  keyframes,
  animationState,
  storyLines,

  allMaterials,
  allBackdrops,
  allShaders,

  // admin
  qualities,

  // transient
  project: projects['p1'],
  models: projects['p1'].models,
  model: projects['p1'].models['m1'],
  valuesModel: projects['p1'].models['m1'].valuesModel,
  materials: projects['p1'].models['m1'].materials,
  generator: generators['g1'],
  parameters: generators['g1'].parameters,
  groups: generators['g1'].groups,
  holodeckStateForce: holodeckState,

  _lastAction: {
    type: '',
  },
};
